export var MIN_PASSWORD_LENGTH = 8;
export var somethingWentWrongPleaseTryAgainOrContactUs = function(strictLocalize) {
    return strictLocalize({
        id: "0pX8fF",
        defaultMessage: [
            {
                type: 0,
                value: "Something went wrong, please try again or contact us."
            }
        ]
    });
};
export var ENABLE_CONSUMER_MODE = "enable-consumer-mode";
